// extracted by mini-css-extract-plugin
export default {"likesWrapper":"_c084098f","noHover":"_c8cae403","dropdownBodyWrapper":"_c3b3c9fc","dropdown":"_eacb6b5f"};